<template>
  <div v-if="arma">
    <BaseSelect class="ui-form-field" v-model="arma.fk_idEstatus" label="Estatus" :items="estatusArma"></BaseSelect>
    <div class="d-flex justify-center mt-2">
      <TextButton
        class="ui-module-btn-solid"
        :disabled="loading"
        :loading="loading"
        @click="triggerUpdateEstatusArma()"
      >
        Guardar cambios
      </TextButton>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import BaseSelect from '../../../base/BaseSelect.vue'
import TextButton from '../../../base/TextButton.vue'

export default {
  components: {
    BaseSelect,
    TextButton,
  },

  data() {
    return {
      selectedArma: null,
      loading: false,
    }
  },

  computed: {
    ...mapGetters('estatusArma', {
      estatusArma: 'getEstatusArma',
    }),
    ...mapGetters('arma', {
      arma: 'getSelectedArma',
    }),
  },

  methods: {
    ...mapActions('arma', ['fetchArmas', 'updateEstatusArma']),
    ...mapActions('dialog', ['closeDialog']),

    async triggerUpdateEstatusArma() {
      this.loading = true
      await this.updateEstatusArma({
        idArma: this.arma.idArma,
        fk_idEstatus: this.arma.fk_idEstatus,
      })

      await this.fetchArmas()
      this.closeDialog()
    },
  },
}
</script>

<style scoped>
::v-deep .ui-form-field .v-input__slot,
::v-deep .v-select .v-input__slot {
  border-radius: 12px !important;
  border: 1px solid rgba(108, 92, 231, 0.25) !important;
  background: rgba(16, 16, 30, 0.35) !important;
}

::v-deep .ui-form-field .v-input__slot:hover,
::v-deep .v-select .v-input__slot:hover {
  border-color: rgba(108, 92, 231, 0.45) !important;
}

::v-deep .ui-form-field .v-input__control,
::v-deep .v-select .v-input__control {
  background: transparent !important;
  border-radius: 12px;
  border: none !important;
  box-shadow: none !important;
}

::v-deep .ui-form-field .v-select__selection,
::v-deep .ui-form-field .mdi-menu-down,
::v-deep .v-select .v-select__selection {
  color: #e0e0e0 !important;
}

::v-deep .ui-form-field .v-label,
::v-deep .v-select .v-label {
  color: rgba(224, 224, 224, 0.7) !important;
}

::v-deep .ui-form-field.v-input--is-focused .v-label,
::v-deep .v-select.v-input--is-focused .v-label {
  color: #a29bfe !important;
}

::v-deep .ui-module-btn-solid.v-btn {
  background-color: var(--v-secondary-base) !important;
  border-radius: 14px !important;
  text-transform: none !important;
  font-weight: 700 !important;
}

::v-deep .ui-module-btn-solid.v-btn.v-btn--disabled {
  background-color: var(--v-secondary-base) !important;
  opacity: 0.5 !important;
}
</style>
